/**
 * HOW TO CONFIGURE APP ENVIRONMENTS
 * ---------------------------------
 * Every new environment needs a `src/environments/app-${key}.ts` file.
 * In order to have a `whatever` environment:
 *  1. create a file called `src/environments/app-whatever.ts` which calls `setupConfig(whatever)` with `whatever` config
 *  2. run `stencil build --env-whatever`,
 *
 * Idea: @see https://medium.com/stencil-tricks/environment-variables-with-stenciljs-57e9da591280
 */
export interface IEnvironmentConfig {
    // env: keyof typeof config;
    env: string;
    showTestBanner?: boolean;
    testBannerMessage?: string;
    userFrontentUrl: string;
    apiEndpoints: IApiEndpoint[];
    wsServer?: string;
    isMobileNative?: boolean;
    isUserEnabled: boolean;
    isSkipLogin: boolean;
    isRouterHash?: boolean;
    isWSEnabled?: boolean;
    gaTracker: string;
    version: string;
    compilationTime: string;
    defaultPushChannelId: string;
    isReduxLoggerEnabled?: boolean;
    vapidPublicKey?: string;
    blablatec?: IBlaBlaTecConfig;
}

export interface IBlaBlaTecConfig {
    apiUrl: string;
    appId: string;
    appToken: string;
}

export interface IApiEndpoint {
    key: string;
    url: string;
}

// eslint-disable-next-line import/no-mutable-exports
let ENV: IEnvironmentConfig;
export { ENV };

// export const setupConfig = (env: keyof typeof config) => ENV = config[env];
export const setupConfig = (env: IEnvironmentConfig) => {
    ENV = env;
    if (ENV.env === 'production') {
        // Disable console logs
        // eslint-disable-next-line no-console
        ['log', 'debug', 'warn', 'info'].forEach(m => (console[m] = () => { }));
    }
};
